import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import {
    IntradayRatesIndicesResponse,
    KeyRateIndicatorsResponse,
    YieldCurveData,
} from 'TargetRatesApp/interfaces/target-rates-endpoints.interfaces';

import { AjaxService } from 'Angular/services/core/ajax.service';
import { UrlsService } from 'Angular/services/core/urls.service';

import { formFlattenedObject } from 'Angular/utils/urls';

@Injectable({
    providedIn: 'root',
})
export class TargetRatesService {
    constructor(private ajaxService: AjaxService, private urlsService: UrlsService) {}

    /**
     * Returns the Yield Curve Data for the Charrt
     *
     * @param dates: dates to request
     */
    getYieldCurveData(datesList: string[]): Observable<YieldCurveData> {
        const dates = datesList.join();
        const url = this.urlsService.TARGET_RATES.YIELD_CURVE_DATA;
        return this.ajaxService.getDataObserveBody<YieldCurveData>(url, { dates });
    }

    getChartSaveAsImageUrl(datesList: string[]): Observable<HttpResponse<{ image_url: string }>> {
        const baseUrl = this.urlsService.EMBEDS.SAVE_AS_IMAGE_YIELD_CURVE_CHART;
        const dates = datesList.join();
        const state = { dates, partner: 'pdf_yield_curve' };
        const data = formFlattenedObject(state, ['dates', 'partner']);
        return this.ajaxService.postFormEncodedDataObserveResponse<{ image_url: string }>(baseUrl, data);
    }

    getYieldCurveUrl(datesList: string[]): string {
        const chartDataBaseUrl = this.urlsService.TARGET_RATES.YIELD_CURVE_DATA_CSV;
        const dates = datesList.join();
        return this.urlsService.getUrl(chartDataBaseUrl, {}, { dates });
    }

    getIntraDayRatesIndices(): Observable<IntradayRatesIndicesResponse> {
        const url = this.urlsService.TARGET_RATES.INTRADAY_RATES_DATA;
        return this.ajaxService.getDataObserveBody<IntradayRatesIndicesResponse>(url);
    }

    getKeyRatesIndicators(): Observable<KeyRateIndicatorsResponse> {
        const url = this.urlsService.TARGET_RATES.KEY_RATES_INDICATORS;
        return this.ajaxService.getDataObserveBody<KeyRateIndicatorsResponse>(url);
    }

    getDownloadPdf(datesList: string[], showRecessions: boolean): Observable<any> {
        const dates = datesList.join();
        const url = this.urlsService.TARGET_RATES.PDF_REPORT;
        const queryParams = {
            dates,
            show_recessions: showRecessions,
        };
        return this.ajaxService.getDataObserveBody(url, queryParams);
    }
}
